$(document).ready(function() {
	if(!document.querySelector('.GPC0068')) return false;

	
	var componentCarouselSimple = {
		$el : null,
		init : function() {
			this.$el = $('.GPC0068');
			this.$el.find('.carousel-wrap-box').each(function(){
				/* LGEGMC-324 20200715 modify */
				var $this = $(this);
				var $carouselBox = $this.find('.carousel-wrap .carousel-box');
				if ($carouselBox.length) {
					componentCarouselSimple.runSlick($this);

					$carouselBox.each(function(){
						var $target = $(this).find('video:visible[autoplay][muted]');
						if ($target.length) {
							setTimeout(function(){
								var targetVideo = $target[0];
								(targetVideo.paused && targetVideo.muted) && targetVideo.play();
							},300);
						}
					});
				}
				/* //LGEGMC-324 20200715 modify */
			});
		},
		runSlick: function($obj) {
			var fontColor = 'black';
			if($obj.find('.carousel-wrap .carousel-box').eq(0).hasClass('text-white')) {
				fontColor = 'white';
			}

			/* LGEIN-554 Start */
			var countryCode = $('html').data('countrycode'),
				slideDirLtr = countryCode == 'in' ? true : false;
			/* //LGEIN-554 End */

			var $slick = $obj.find('.carousel-wrap').slick({
				infinite: slideDirLtr, // WA-GPC0068-01, LGEIN-554
				listStyle: true, // WA-GPC0068-01
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows : true,
				dots: false,
				//adaptiveHeight: true,
				lazyLoad: 'ondemand',
				//autoplay: true,
				//autoplaySpeed: 10000,
				prevArrow: carouselOptions.bigAnglePrev, // common.js variable
				nextArrow: carouselOptions.bigAngleNext, // common.js variable
				appendDots:$obj.find('.slick-dot-wrap'),
				responsive: [
					{
					  breakpoint: 768,
					  settings: {
						dots: true
					 }
					}
				]
			});
			
			/* LGEITF-520 Start */
			$obj.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				var $video = $obj.find('.carousel-box[data-slick-index='+nextSlide+'] .animation-area video:visible');
				if($video.length && !(!!$video.find('source').attr('src'))){
					$video.find('source').attr('src', $video.find('source').data('src'))
					$video.get(0).load()
				}
			});
			/* LGEITF-520 End */ 
			
			$obj.find('.carousel-wrap').addClass('slick-'+fontColor);
			$obj.find('.carousel-wrap').on('afterChange', function(event, slick, currentSlide){
				if($obj.find('.carousel-wrap').find('.slick-current').hasClass('text-white')) {
					fontColor = 'white';
				} else {
					fontColor = 'black';
				}
				$obj.find('.carousel-wrap').removeClass('slick-white').removeClass('slick-black').addClass('slick-'+fontColor);
			});
			
			/* LGCOMSPEED-10 Start */
			var lazyVideoEls = [].slice.call(document.querySelectorAll(".GPC0068 video.lazy"));

		    if ("IntersectionObserver" in window) {

		        var lazyloadVideoObserver = new IntersectionObserver(function (entries, observer) {
		            entries.forEach(function (video) {
		                if (video.isIntersecting) {

		                    lazyloadVideo(video.target); 

		                    video.target.load();
		                    video.target.oncanplay = function() {
		                        video.target.play();
		                    }

		                    lazyloadVideoObserver.unobserve(video.target);
		                }
		            });
		        });

		        lazyVideoEls.forEach(function(videoEl) {
		            lazyloadVideoObserver.observe(videoEl);
		        });

		    } else { 

		        lazyVideoEls.forEach(function(videoEl) {

		            lazyloadVideo(videoEl);
		            
		            videoEl.load();
		            videoEl.oncanplay = function() {
		                videoEl.play();
		            }

		        });

		    }
		    /* LGCOMSPEED-10 End */
		}
	};
	componentCarouselSimple.init();
	
	/* LGEITF-520 Start */
	$(window).resize(function(){
	    var $video = componentCarouselSimple.$el.find('.carousel-box.slick-current .animation-area video:visible'); 
		if($video.length && !(!!$video.find('source').attr('src'))){
			$video.find('source').attr('src', $video.find('source').data('src'))				
			$video.get(0).load()
		}
	});
	/* LGEITF-520 End */	
});